import { render, staticRenderFns } from "./KreatywnaDruzynowa.vue?vue&type=template&id=3a482bf6&scoped=true&"
import script from "./KreatywnaDruzynowa.vue?vue&type=script&lang=js&"
export * from "./KreatywnaDruzynowa.vue?vue&type=script&lang=js&"
import style0 from "./KreatywnaDruzynowa.vue?vue&type=style&index=0&id=3a482bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a482bf6",
  null
  
)

export default component.exports